import { updateIdentityCertification } from './queries/account';
import fetchQuotationChatMessages from './queries/chatMessages';
import fetchMyReceivedQuotations from './queries/myQuotations';
import { fetchMyPaymentDataByQuotationUser } from './queries/payment';
import fetchPurchaseOrders from './queries/purchaseOrder';
import fetchQuotationUserRfqs from './queries/rfqs';

export const handlers = [
  fetchMyReceivedQuotations,
  fetchQuotationUserRfqs,
  fetchMyPaymentDataByQuotationUser,
  updateIdentityCertification,
  fetchPurchaseOrders,
  fetchQuotationChatMessages
];
